import styled from 'styled-components'

import Link from 'components/Next/Link'
import { useRouter } from 'next/router'

const navs = [
  {
    name: 'Portfolio',
    icon: 'hand-holding-usd',
    href: '/'
  },
  {
    name: 'Performance',
    icon: 'chart-bar',
    href: '/performance'
  },
  {
    name: 'Analytics',
    icon: 'chart-pie',
    href: '/analytics'
  },
  {
    name: 'WNY28',
    icon: 'chart-line',
    href: '/western-new-york-28-index'
  },
  {
    name: 'About',
    icon: 'info-circle',
    href: '/about'
  },
]

const sidebarExpanded = false

const Nav = ({  }) => {
  const router = useRouter()
  return (
    <>
      {
        navs.map(({ name, icon, href }, index) => 
          <Link href={href} shallow={true} fill={true}>
            <S_NavOption 
              active={
                href === '/'
                  ? router.pathname === '/' || router.pathname.includes('/holdings')
                  : router.asPath.includes(href)
              } 
              key={`navOption${index}`} 
              expanded={sidebarExpanded}
            >
              
              <S_NavContent expanded={sidebarExpanded}>
                <S_Icon className={`fa fa-${icon}`} />
                <S_Text shrink={!sidebarExpanded}>{ name }</S_Text>
              </S_NavContent>
              
            </S_NavOption>
          </Link>
        ) 
      }
    </>
  )
}

export default Nav


const S_NavOption = styled.div`
  cursor: pointer;
  background: ${props => props.active ? 'var(--Primary)' : 'none'};
  display: flex;
  flex-wrap: wrap;
  justify-content: ${props => props.expanded ? 'auto' : 'center'};
  align-items: center;
  height: var(--Header_Height);
  color: var(--Font_Color);
  flex-grow: 1;

  * {
    color: ${props => props.active ? 'var(--Font_Color_Invert)' : 'var(--Font_Color_Label)'};
  }
`

const S_NavContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${props => props.expanded ? '0' : '8px'};
  height: ${props => props.expanded ? '100%' : 'auto'};
  align-items: ${props => props.expanded ? 'center' : 'auto'};
  flex-grow: 1;
`

const S_Icon = styled.i`
  font-size: var(--Font_Size_Icon_Small);
  width: 100%;
  display: flex;
  justify-content: center;
`

const S_Text = styled.div`
  font-size: ${props => props.shrink ? '11px' : 'var(--Font_Size_Title)'};
  letter-spacing: var(--Letter_Spacing_Title);
  width: 100%;
  text-align: center;

  /* text-transform: uppercase;
  font-weight: 600; */
`